/**
 * Where players reach the game and its operator, named once for the client
 * (welcome screen, HUD) and the server (the mails, ADR 0056). The legal pages
 * (apps/client/public/legal/) spell out the same address.
 */
/** The community server's permanent invite (created on #bienvenue, never expires). */
export const DISCORD_INVITE = 'https://discord.gg/6XztZnBMu8';
export const CONTACT_EMAIL = 'contact@shefira.com';
/** The game's Instagram profile. */
export const INSTAGRAM_URL = 'https://www.instagram.com/playshefira/';
//# sourceMappingURL=community.js.map